import React from 'react';
import { CheckIcon } from 'lucide-react';
import { audienceItems, timeValueTasks } from '../data/mat';
export function Audience() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-19" data-mp="3p1x9uy7gfspq">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-20" data-mp="6vskciel1hux">
        <div className="lg:col-span-7" data-id="element-21" data-mp="1vwgcj5vxqfd">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-22" data-mp="1uv265tkontf">
            Dla kogo jest <em className="text-red-700" data-id="element-23" data-mp="gqsx5krrfm42">MATEMATYKA GOTOWA™</em>?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-900/75" data-id="element-24" data-mp="btax6jvq0h87">Pakiet jest dla Ciebie, jeśli:</p>
          <ul className="mt-8 grid gap-x-8 border-t border-slate-900/15 sm:grid-cols-2" data-id="element-25" data-mp="pkfpf0wre78i">
            {audienceItems.map(item => <li key={item} className="flex gap-3 border-b border-slate-900/10 py-4 leading-snug text-slate-900/80" data-id="element-26" data-mp="llqcf9fmurpe">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-27" data-mp="ukbr2thzhmkw" />
                {item}
              </li>)}
          </ul>
          <p className="mt-8 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-28" data-mp="16et0v8tbeabo">
            Stworzony dla nauczycieli, którzy chcą poświęcać mniej czasu na przygotowania, a więcej na uczniów.
          </p>
        </div>

        <aside className="self-start rounded-3xl bg-slate-900 p-8 text-stone-50 sm:p-11 lg:col-span-5" data-id="element-29" data-mp="1kcr7tt5b34h5">
          <h3 className="font-serif text-3xl leading-tight sm:text-4xl" data-id="element-30" data-mp="1pc3v2f03adk9">Ile jest wart Twój czas?</h3>
          <p className="mt-4 leading-relaxed text-stone-50/75" data-id="element-31" data-mp="1uankwqht09hw">
            Pomyśl, ile godzin co tydzień poświęcasz na przygotowanie lekcji matematyki:
          </p>
          <ul className="mt-5 divide-y divide-white/10 border-y border-white/10" data-id="element-32" data-mp="1z3qeuzqhtkym">
            {timeValueTasks.map(task => <li key={task} className="py-3 text-[15px] text-stone-50/85" data-id="element-33" data-mp="242ji7zc2fvl2">
                {task}
              </li>)}
          </ul>
          <p className="mt-6 leading-relaxed text-stone-50/75" data-id="element-34" data-mp="2d0vf2j3izply">
            A teraz wyobraź sobie uporządkowany pakiet, który pomaga Ci w tym wszystkim – przez cały rok szkolny.
          </p>
          <p className="mt-4 font-serif text-xl italic leading-snug text-red-300" data-id="element-35" data-mp="8y3ojxk5e3g4">
            Nie musisz już zaczynać od zera.
          </p>
        </aside>
      </div>
    </section>;
}